








































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class OffsetCard extends Vue {
  @Prop() public title!: string;
  @Prop() public height!: number;
  @Prop() public minWidth!: number;
  @Prop() public contentClass!: string;
  @Prop() public contentStyle!: string;
  @Prop() public avatarClass!: string;
  @Prop({ type: String, default: 'purple' }) public color!: string;
  @Prop({ type: String, default: 'mdi-store' }) public icon!: string;
  @Prop({ type: Boolean, default: false }) public closable!: boolean;
  @Prop({ type: Boolean, default: false }) public fit!: boolean;  // 自适应窗口高度

  public get containerClass() {
    return {
      'offset-card-container': this.fit,
    };
  }

  public get wrapCls() {
    const classList: string[] = ['pt-0'];
    if (this.contentClass) {
      classList.push(this.contentClass);
    }
    if (this.fit) {
      classList.push('offset-card-content');
    }
    return classList.join(' ');
  }

  @Emit('close')
  private onClose() {
    return;
  }
}
